import cx from "classnames";
import React from "react";

import { CardSection } from "../Card";

import { CLASS_SECTION } from "./constants";

export interface PromotionCardSectionProps {
  /** Inverse colors */
  isInverse?: boolean;
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const PromotionCardSection: React.FC<PromotionCardSectionProps> = ({
  className,
  children,
  ...other
}) => {
  const classes = cx(CLASS_SECTION, className);
  return (
    <CardSection className={classes} {...other}>
      {children}
    </CardSection>
  );
};

PromotionCardSection.displayName = "PromotionCardSection";
